import { render } from "./JobPosting.vue?vue&type=template&id=31692e44&scoped=true"
import script from "./JobPosting.vue?vue&type=script&lang=js"
export * from "./JobPosting.vue?vue&type=script&lang=js"

import "./JobPosting.vue?vue&type=style&index=0&id=31692e44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31692e44"]])

export default __exports__